import { css } from "styled-components";

import MapControlButtonStyle from "./MapControlButtonStyle";

const MapControlFullscreenStyle = (icon = null) => css`
  ${MapControlButtonStyle(icon)};
`;

export default MapControlFullscreenStyle;
